import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { checkFieldsValidity } from '../../shared/index';
import { ManageForeclosureAuctionService } from '../manage-foreclosure-auction.service';
import { Listbox } from 'primeng/listbox';
import { Table } from 'primeng/table';
import { ForeclosureAuctionChangeLogSearchParams } from '../models/ForeclosureAuction';
import { ChangeLog } from '../models/ForeclosureAuctionChangeLog'

@Component({
  selector: 'app-change-log-foreclsoure-auction',
  templateUrl: './change-log-foreclsoure-auction.component.html',
  styleUrls: ['./change-log-foreclsoure-auction.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ChangeLogForeclsoureAuctionComponent implements OnInit {
  
  @Output() closeDialog = new EventEmitter<boolean>();
  @Input() showDialog: boolean;
  @ViewChild('dt') table: Table;

  // Take the List box references
  @ViewChild('listboxChangedBy') listboxChangedBy: Listbox;
  @ViewChild('listboxTrsustee') listboxTrsustee: Listbox;
  @ViewChild('listboxStates') listboxStates: Listbox;

  changeLogForm: FormGroup;
  minDate: Date;
  maxDate: Date;
  formSubmitted: boolean;
  disableChangeLogForm: boolean;
  changedBy: any[];
  states: any[];
  county: any[];
  showChangeByCheckBox: boolean = true;
  showStateCheckBox: boolean = true;
  showCountyCheckBox: boolean = true;
  showChangedbyFilter: boolean = true;
  showStatesFilter: boolean = true;
  showCountyFilter: boolean = true;
  disableStateCheckBox: boolean = false;
  disableChangedCheckBox: boolean = false;
  disableCountyCheckBox :boolean =false
  data: ChangeLog [];
  loading: boolean;
  records: any;
  reqParams : ForeclosureAuctionChangeLogSearchParams;
  cols: any [];
  selectedChangedByUsers: any[];
  selectedStates:any [];
  selectedCounty:any[];

  constructor(private manageForeclosureAuctionService: ManageForeclosureAuctionService) { }

  ngOnChanges() {
    this.resetForm();
  }

  resetForm() {
    if (this.changeLogForm != undefined) {
      this.changeLogForm.reset();
      this.data = [];
      this.formSubmitted = false;
      this.listboxChangedBy.filterValue = '';
      this.listboxStates.filterValue = '';
      this.listboxTrsustee.filterValue = '';
    }

  }

  ngOnInit() {
    this.changedBy = [{ name: 'Loading..', code: 'Loading..' }];
    this.states = [{ name: 'Loading..', code: 'Loading..' }];
    this.county = [{ name: 'Loading..', code: 'Loading..' }];
    this.changeLogForm = new FormGroup({
      changedBy: new FormControl('', null),
      states: new FormControl('', null),
      county: new FormControl('', null),
      toDate: new FormControl('', null),
      fromDate: new FormControl('', null)
    }, checkFieldsValidity(Validators.required));

    this.formSubmitted = false;
    this.formControlValueChanged();
    this.manageForeclosureAuctionService.getSelectorsData().subscribe(res => {
      console.log(res);
      res.data[0].ChangedBy.length == 0 ? (this.changedBy = [{ name: 'No data', Code: 'No data' }], this.showChangeByCheckBox = false, this.disableChangedCheckBox = true, this.showChangedbyFilter = false) : (this.changedBy = res.data[0].ChangedBy);
      res.data[0].States.length == 0 ? (this.states = [{ name: 'No data', Code: 'No data' }], this.showStateCheckBox = false, this.disableStateCheckBox = true, this.showStatesFilter = false) : (this.states = res.data[0].States);
      res.data[0].County.length == 0 ? (this.county = [{ name: 'No data', Code: 'No data' }], this.showCountyCheckBox = false, this.disableCountyCheckBox = true, this.showChangedbyFilter = false) : (this.county = res.data[0].County);
    });

    // "CurrentStateName": "California",
    // "PreviousAuctionLocationDetails": null,
    // "CurrentAuctionLocationAddress": null,
    // "PreviousCounty": "ALPINE",
    // "PreviousIsStatutoryLocation": 0,
    // "CurrentisActive": 0,
    // "PreviousIsActive": 1,
    // "FcMatrixAuditId": 6,
    // "PreviousStateName": "California",
    // "CurrentIsStatutoryLocation": 0,
    // "CurrentAuctionLocationDetails": null,
    // "PreviousAuctionLocationAddress": "4000 Oxford Road 91903",
    // "FcMtrixId": 5,
    // "CurrentCounty": "ALPINE"

    this.cols = [
      { field: 'CRUDDate', header: 'Changed Date', showInHeader: true },
      { field: 'ChangeByName', header: 'Changed By', showInHeader: true },
      { field: 'FcMatrixAuditId', header: 'Fc Matrix Audit ID', showInHeader: false },
      { field: 'CurrentStateName', header: 'State', showInHeader: true },
      { field: 'PreviousStateName', header: 'Previous State', showInHeader: false },
      { field: 'CurrentCounty', header: 'County', showInHeader: true },
      { field: 'PreviousCounty', header: 'Previous County', showInHeader: false },
      { field: 'CurrentAuctionLocationAddress', header: 'Auction Location Address', showInHeader: false },
      { field: 'PreviousAuctionLocationAddress', header: 'Previous Auction Location Address', showInHeader: false },
      { field: 'FcMtrixId', header: 'Fc Matrix Id', showInHeader: false },
      { field: 'CurrentAuctionLocationDetails', header: 'Current Auction Location Details', showInHeader: false },
      { field: 'PreviousAuctionLocationDetails', header: 'Previous Auction Location Details', showInHeader: false },
      { field: 'CurrentIsStatutoryLocation', header: 'Statutory Location', showInHeader: false },
      { field: 'PreviousIsStatutoryLocation', header: 'Previous Is StatutoryLocation', showInHeader: false },
      { field: 'CurrentisActive', header: 'Current Is Active', showInHeader: false },
      { field: 'PreviousIsActive', header: 'Previous Is Active', showInHeader: false }
    ];

  }

  formControlValueChanged() {
    this.changeLogForm.get('fromDate').valueChanges.subscribe(
      (newDate: Date) => {
        if (newDate != null && this.maxDate == null) {
          this.disableChangeLogForm = true;
        } else if (newDate > this.maxDate) {
          this.disableChangeLogForm = true;
        } else {
          this.disableChangeLogForm = false;
        }
      });

    this.changeLogForm.get('toDate').valueChanges.subscribe(
      (newDate: Date) => {
        if (newDate != null && this.minDate == null) {
          this.disableChangeLogForm = true;
        } else if (newDate < this.minDate) {
          this.disableChangeLogForm = true;
        } else {
          this.disableChangeLogForm = false;
        }
      });
  }

  dialogHide() {
    this.closeDialog.emit(true);
  }

  setDateRange(days: number): void {
    let tempDate = new Date();
    tempDate.setDate(tempDate.getDate() - days);
    this.minDate = tempDate;
    this.maxDate = new Date();
  }

  isPaginatorVisible(): boolean {
    return (this.data && this.data.length > 0) ? true : false;
  }

  formatParams(data): string {
    const formattedList = [];
    if (data) {
      data.map(item => {
        formattedList.push(item.code);
      });
    }
    return formattedList.toString();
  }

  formatDate(dateObj: Date): string {
    let current_datetime = dateObj;
    let formatted_date = current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate();
    return formatted_date;
  }

  onSubmitChangeLogForm() {
    this.data = [];
    this.reqParams = <ForeclosureAuctionChangeLogSearchParams>{};
    this.reqParams.ChangedBy = this.formatParams(this.changeLogForm.value.changedBy);
    this.reqParams.StateCode = this.formatParams(this.changeLogForm.value.states);
    this.reqParams.County = this.formatParams(this.changeLogForm.value.county);
    this.reqParams.ToDate = this.changeLogForm.value.toDate == null ? '' : this.formatDate(this.changeLogForm.value.toDate);
    this.reqParams.FromDate = this.changeLogForm.value.fromDate == null ? '' : this.formatDate(this.changeLogForm.value.fromDate);
    this.loading = true;
    this.formSubmitted = true;
    // Reset the paginator
    if(this.table)
    this.table.first = 0;

    this.manageForeclosureAuctionService.getChangeLogData(this.reqParams).subscribe(res => {
      console.log(res.data);
      this.data = res.data;
      this.records = res.meta.pagination.TotalRecords;
      this.loading = false;
    });
  }
}
